module.exports = __webpack_public_path__ + "media/images/img-service-intro-lead-ec089482d4d128e2f81823967ae5c238.png";